import { render, staticRenderFns } from "./MovePopup.vue?vue&type=template&id=a56346ca&scoped=true&"
import script from "./MovePopup.vue?vue&type=script&lang=js&"
export * from "./MovePopup.vue?vue&type=script&lang=js&"
import style0 from "./MovePopup.vue?vue&type=style&index=0&id=a56346ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56346ca",
  null
  
)

export default component.exports